import { Currency } from "@redotech/money/currencies";
import {
  createCurrencyConverter,
  CurrencyConverter,
} from "@redotech/money/exchange";
import { useLoad } from "@redotech/react-util/load";
import { lazy } from "@redotech/util/cache";
import { createContext, ReactNode, useContext, useMemo } from "react";
import { RedoMerchantRpcClientContext } from "./rpc-client";

export const CurrencyExchangeContext = createContext<
  () => Promise<CurrencyConverter>
>(async () => {
  throw new Error("Not provided");
});

export const CurrencyExchangeProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const rpcClient = useContext(RedoMerchantRpcClientContext);
  const currencyConverter = useMemo(
    () =>
      lazy(async () => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const rates = await rpcClient!.getExchangeRates(null);
        return createCurrencyConverter(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          new Map(Object.entries(rates) as [Currency, number][]),
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <CurrencyExchangeContext.Provider value={currencyConverter}>
      {children}
    </CurrencyExchangeContext.Provider>
  );
};

/** The converter once exchange rates have loaded, undefined until then. */
export function useCurrencyConverter(): CurrencyConverter | undefined {
  const loadCurrencyConverter = useContext(CurrencyExchangeContext);
  return useLoad(() => loadCurrencyConverter(), [loadCurrencyConverter]).value;
}
